// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1qY0q","description":"PatientConsentPreview_description__3oIcH"};